// @styles 
import { Progress, Tooltip } from 'antd'
import cx from 'classnames';
import usePrismicByUID from "hooks/usePrismicByUID";
import { useContext, useEffect } from "react";
import Context from '../../../context/appContext';

// @utils
import { getPercentage } from 'utils/utils';

import './styles.scss'
import { Fade } from 'react-reveal'

export default function SectionProgress() {
    const { info } = usePrismicByUID('flujo_cotizacion_v2');
    const { formStatus: { steps, currentStep, currentQuestion }, folio, tokenInfo,
        dataForm: { formResponses }, returnButton, showHomePage, setDisabledButtonContinue, progressStep,
        setFormStatus, setProgressStep, setIsSendForm } = useContext(Context);

    useEffect(() => {
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        if (progressStep.length > 0) {
            const index = getIndex();
            let newProgressStep = JSON.parse(JSON.stringify(progressStep));
            newProgressStep[index].current = currentQuestion;
            setProgressStep(newProgressStep);
        }
    }, [currentQuestion]);

    useEffect(() => {
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        if (progressStep.length > 0) {
            const index = getIndex();
            let newProgressStep = JSON.parse(JSON.stringify(progressStep));
            newProgressStep[index].active = true;
            setProgressStep(newProgressStep);
        }
    }, [currentStep]);

    useEffect(() => {
        steps && steps.forEach(step => {

            const newStep = {
                key_step: step.key_step,
                name: step.name,
                current: 0,
                quantity: step.questions.length - 1,
                active: progressStep.length === 0 ? true : false
            }

            const index = progressStep.findIndex(value => value.key_step === step.key_step);
            if (index === -1) {
                progressStep.push(newStep);
            }
        });

    }, [steps]);

    const getIndex = () => {
        const key_step = steps[currentStep].key_step;
        const index = progressStep.findIndex(value => value.key_step === key_step);
        return index;
    }
    return (
        <div className='section-progress__container'>
            <Fade bottom cascade delay={0.3}>
                <div className='container-xl'>
                    <div className='section-progress__container-steps'>
                        <div className={
                            cx(
                                'steps-container',
                                { 'steps-container-finish': progressStep.length === currentStep }
                            )
                        }>
                            <div className='section-progress__container-steps-title'>COTIZA TU AUTO EN MENOS DE 60 SEGUNDOS</div>
                            <div className='steps-container-dots'>
                                {progressStep.map((item, index) => (
                                    <div
                                        className={
                                            cx(
                                                'steps-item',
                                                { 'steps-item-active': item.active }
                                            )
                                        }
                                        key={`step-${index}`}
                                    >
                                        <Tooltip
                                            placement='top'
                                            title={item.name}
                                        >
                                            <div className='steps-item__dot' />
                                        </Tooltip>


                                        <Progress percent={getPercentage(item)} size="small" showInfo={false} />

                                    </div>
                                ))}
                                <Tooltip
                                    placement='top'
                                    title={'Pasarela de pago'}
                                >
                                    <div className='steps-item-last' />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}